import React, { Fragment } from "react";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";

/**
 * @param {boolean} open
 * @param {function} handleClose
 * @param {string} title
 */
const BDialogModal = ({ open, handleClose, title, closeButton, children, ...props }) => {
    return (
        <Fragment>
            <Modal show={open} onHide={handleClose} backdrop="static" {...props}>
                <Modal.Header closeButton={closeButton}>
                    {title && <Modal.Title as="h5">{title}</Modal.Title>}
                </Modal.Header>
                <Modal.Body>{children}</Modal.Body>
            </Modal>
        </Fragment>
    );
};

BDialogModal.defaultProps = {
    title: "",
    open: false,
    handleClose: null,
    closeButton: true
};

BDialogModal.propTypes = {
    title: PropTypes.string.isRequired,
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func,
    closeButton: PropTypes.bool
};

export default BDialogModal;
